const TravelStatusComponent = ({ value }) => {
    return (
        <div>
            <p style={{ color: value?.status?.color, margin: 0 }}>{value?.status?.name}</p>
        </div>
    )
}

export default TravelStatusComponent;